import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Container, {
  Card,
  Cards,
  ContainerWithBackground,
  ContainerWithImage,
  TitleText,
} from "../components/container"

const IndexPage = () => (
  <Layout lang="en">
    <Seo title="Home" lang="en" />
    <div
      style={{
        height: "80vh",
        minHeight: 600,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        textAlign: "center",
        padding: "0 1rem",
      }}
    >
      <TitleText className={"clip-text"}>
        {"Make a Difference with "}
        <span style={{ display: "block" }}>Visual Timer by Yong</span>
      </TitleText>
      <span
        style={{
          fontSize: 22,
          display: "block",
          marginTop: 32,
          color: "#b16b6b",
          wordBreak: "keep-all",
        }}
      >
        Use your little time productively to open great possibilities
      </span>
      <div style={{ marginTop: 50 }}>
        <a
          href="https://apps.apple.com/app/id1458639178"
          style={{ padding: 20 }}
        >
          <img
            src="/en-download.svg"
            style={{ width: 160 }}
            alt={"Download the app"}
          />
        </a>
      </div>
    </div>
    <ContainerWithBackground
      backgroundColor={"#f9f9f1"}
      containerStyle={{
        marginBottom: `4rem`,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <StaticImage
          src="../images/en_0timer_framed.png"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
          style={{ flex: 1 }}
        />

        <StaticImage
          src="../images/en_0timer2_framed.png"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
          style={{ flex: 1 }}
        />

        <StaticImage
          src="../images/en_0timer3_framed.png"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
          style={{ flex: 1 }}
        />
      </div>
    </ContainerWithBackground>
    <Container>
      <ContainerWithImage
        title={"Set your time. Start your task."}
        desc={`Visual Timer provides various settings and options to optimize your workflow.
          You can change everything from duration to color.`}
      >
        <StaticImage
          src={"../images/en_0setting_framed.png"}
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt={""}
          style={{ flex: 1 }}
        />
      </ContainerWithImage>
      <ContainerWithImage
        reversed={true}
        title={"Prepare presets. Start your routines."}
        desc={`Any repeatable tasks can be your preset. Make a timer for your routines and accompany with your task.`}
      >
        <StaticImage
          src="../images/en_0preset_framed.png"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
          style={{ flex: 1 }}
        />
      </ContainerWithImage>
      <ContainerWithImage
        title={"Embrace the power of small wins."}
        desc={`A great performance deserves a celebration.
        Change completion effects based on your preferences: vibration, sounds, flashlight, images to reveal.`}
      >
        <StaticImage
          src="../images/en_0ending-effect_framed.png"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="A Gatsby astronaut"
          style={{ flex: 1 }}
        />
      </ContainerWithImage>

      <div>
        <h2 style={{ color: "#4c00d1" }}>{"Main Features"}</h2>
        <Cards>
          <Card
            title={"Presets"}
            desc={`Prepare your preset for your task. Quick start leads to finish.`}
          />
          <Card
            title={"Reminders"}
            desc={`Add more reminders to handle complicated tasks. Add a note and sounds as breadcrumbs.`}
          />
          <Card
            title={"Repeat"}
            desc={`Repeat a whole timer as much as you want.`}
          />
          <Card
            title={"Landscape/Multitasking support"}
            desc={`Visual Timer is avilable to use on iPhone and iPad. The layout optmized for the both mode, landscape and portrait.`}
          />
          <Card
            title={"Various completion effects"}
            desc={`Set your favorite effects: Sounds, vibration, flashlight, images to reveal.`}
          />
          <Card
            title={"Title as a mini note"}
            desc={`Tap the title on presets screen. Add a note or inspirational quote easily.`}
          />
          <Card
            title={"Open preset or last timer"}
            desc={`Decide the first screen of the app: a list of timer or the last-used timer.`}
          />
          <Card
            title={"Styles"}
            desc={`You can change every color of the timer using a flexible color picker.`}
          />
          <Card
            title={"Change timer display"}
            desc={`Change timer display setting such as a direction of movement, size of display.`}
          />
          <Card
            title={"3 types of duration control"}
            desc={`Visual Timer provides wheel, buttons, and gestures mode for duration control.`}
          />
          <Card
            title={"Quick action buttons"}
            desc={`You can quickly change certain settings such as brightness, sounds, vibrations.`}
          />
          <Card
            title={"Default templates provided"}
            desc={`Visual Timer comes with basic presets. Create the timer using templates.`}
          />
          <Card
            title={"Share the timer"}
            desc={`Share your timer setting with others using a QR code or a link.`}
          />
        </Cards>
        <p>
          The timer is constantly being updated! Any problems or suggestions,
          please feel free to{" "}
          <a href="mailto:visualtimer@edykim.com">leave feedback</a>.
        </p>
      </div>
    </Container>
    <div style={{ background: "#330033", height: "40vh", minHeight: 400 }}>
      <Container>
        <div
          style={{
            height: "40vh",
            minHeight: 400,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              color: "#ffffff",
              display: "block",
              fontSize: 42,
              letterSpacing: -1,
              fontWeight: "900",
              lineHeight: 1.2,
              textAlign: "center",
              wordBreak: "keep-all",
              marginBottom: 10,
            }}
          >
            Your favorite timer, now on your phone.
          </span>
          <a
            href="https://apps.apple.com/app/id1458639178"
            style={{ padding: 20 }}
          >
            <img
              src="/en-download.svg"
              style={{ width: 220, margin: 0 }}
              alt={"Download the app"}
            />
          </a>
        </div>
      </Container>
    </div>
  </Layout>
)

export default IndexPage
